// extracted by mini-css-extract-plugin
export default {"BackButton":"Container_BackButton__dnBT9","Title":"Container_Title__Ccqf-","Header":"Container_Header__bC6h2"};